import {Button, Select} from '@material-ui/core';
import * as globals from '@wandb/weave/common/css/globals.styles';
import {hexToRGB} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

import {QuickStartAnalyticsOrigin} from '../../services/analytics/quickStartEvents';

export const QuickStartContainer = styled.div<{
  $maxWidth: number;
}>`
  background-color: white;
  width: 100%;

  @media (min-width: ${props => props.$maxWidth}px) {
    display: flex;
    justify-content: center;
  }
`;
QuickStartContainer.displayName = 'S.QuickStartContainer';

export const QuickStart = styled.div`
  background-color: white;
  max-width: 800px;
`;
QuickStart.displayName = 'S.QuickStart';

export const QuickStartIcon = styled.span`
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
QuickStartIcon.displayName = 'S.QuickStartIcon';

export const QuickStartHeader = styled.header`
  margin-bottom: 24px;
`;
QuickStartHeader.displayName = 'S.QuickStartHeader';

export const QuickStartHeaderText = styled.h1`
  font-weight: 600;
  font-size: 24px;
  line-height: 40px;
  color: ${globals.MOON_950};

  margin-bottom: 8px;
`;
QuickStartHeaderText.displayName = 'S.QuickStartHeaderText';

export const QuickStartFrameworkSelectionRow = styled.div<{
  $maxWidth: number;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 32px;
  margin-bottom: 24px;

  @media only screen and (max-width: ${props => props.$maxWidth}px) {
    flex-wrap: wrap;
    height: fit-content;
  }
`;
QuickStartFrameworkSelectionRow.displayName =
  'S.QuickStartFrameworkSelectionRow';

export const QuickStartFrameworkSelectionLabel = styled.h2`
  font-weight: 600;
  font-size: 18px;
  line-height: 32px;
  color: ${globals.MOON_950};

  margin-bottom: 0;
  margin-right: 10px;
`;
QuickStartFrameworkSelectionLabel.displayName =
  'S.QuickStartFrameworkSelectionLabel';

export const ResponsiveContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-content: center;

  @media (max-width: ${globals.MEDIUM_BREAKPOINT}px) {
    flex-wrap: wrap;
    height: fit-content;
  }
`;
ResponsiveContainer.displayName = 'S.ResponsiveContainer';

export const QuickStartFrameworkOptions = styled.div<{
  $maxWidth: number;
}>`
  display: flex;
  flex-direction: row;

  > * {
    margin-right: 10px;
    :last-child {
      margin-right: 0;
    }
  }

  @media (max-width: ${props => props.$maxWidth}px) {
    flex-wrap: wrap;
    height: fit-content;
    > * {
      margin-top: 10px;
    }
  }
`;
QuickStartFrameworkOptions.displayName = 'S.QuickStartFrameworkOptions';

export const QuickStartFrameworkSelect = styled(Select)`
  min-width: 242px;
  max-width: 242px;
  height: 32px;

  .MuiSelect-select:focus {
    background-color: white;
  }

  .MuiOutlinedInput-input {
    padding: 0 0 0 8px;
  }
`;
QuickStartFrameworkSelect.displayName = 'S.QuickStartFrameworkSelect';

export const FrameworkItem = styled.div`
  display: flex;
  align-items: center;
`;
FrameworkItem.displayName = 'S.FrameworkItem';

export const FrameworkSelectionConjunction = styled.div`
  width: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
FrameworkSelectionConjunction.displayName = 'S.FrameworkSelectionConjunction';

export const ColabButton = styled(Button)`
  background: ${globals.GRAY_TRANSPARENT};
  border-radius: 4px;
  margin-left: 10px;

  .MuiButton-label {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #33383d;
  }
`;
ColabButton.displayName = 'S.ColabButton';

export const UserApiKeyRow = styled.div<{
  analyticsOrigin: QuickStartAnalyticsOrigin;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 16px;
  width: 100%;

  background-color: ${hexToRGB(globals.GOLD_300, 0.48)};
  border-radius: 8px;
  color: ${globals.GOLD_600};

  @media only screen and (max-width: ${globals.MOBILE_WIDTH}px) {
    flex-wrap: wrap;
    align-content: center;
    height: fit-content;

    > :first-child {
      margin-bottom: 10px !important;
    }
  }

  ${props =>
    props.analyticsOrigin === QuickStartAnalyticsOrigin.QUICKSTART_PAGE &&
    css`
      @media only screen and (max-width: ${globals.SMALL_TABLET_WIDTH}px) and (min-width: ${globals.TABLET_BREAKPOINT}) {
        flex-wrap: wrap;
        align-content: center;
        height: fit-content;

        > :first-child {
          margin-bottom: 10px !important;
        }
      }
    `}
`;
UserApiKeyRow.displayName = 'S.UserApiKeyRow';

export const UserApiKeyLabel = styled.div`
  display: flex;
  margin: 0;

  > * {
    margin-right: 10px;
  }
`;
UserApiKeyLabel.displayName = 'S.UserApiKeyLabel';

export const UserApiKeyBox = styled.div`
  color: ${globals.MOON_800};
  background-color: white;
  border-radius: 4px;
  border: 1px solid ${globals.GOLD_600};

  display: flex;
  align-content: center;
  height: 32px;
  max-width: 242px;
  min-width: 242px;
  padding: 4px 6px 4px 12px;

  p {
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 4px;
    white-space: nowrap;
  }

  :hover {
    cursor: pointer;
    outline: 1px solid rgba(199, 121, 5, 0.6);
    border-color: rgba(199, 121, 5, 0.6);
  }
`;
UserApiKeyBox.displayName = 'S.UserApiKeyBox';

export const QuickStartOrderedList = styled.ol`
  padding-left: 0px;
  list-style-position: inside;

  > * {
    margin-bottom: 28px;
    :last-child {
      margin-bottom: 0;
    }
  }
`;
QuickStartOrderedList.displayName = 'S.QuickStartOrderedList';

export const QuickStartListItem = styled.li`
  color: ${globals.MOON_950};
  font-weight: 600;
  font-size: 18px;
  line-height: 32px;

  margin-bottom: 8px;

  ::marker {
    color: ${globals.MOON_950};
    font-weight: 600;
    font-size: 18px;
    line-height: 32px;
  }
`;
QuickStartListItem.displayName = 'S.QuickStartListItem';

export const QuickStartStepContent = styled.div`
  > * {
    margin-bottom: 8px;
    :last-child {
      margin-bottom: 0;
    }
  }
`;
QuickStartStepContent.displayName = 'S.QuickStartStepContent';
